// extracted by mini-css-extract-plugin
export default {"button":"Q5xCt"};